import type { ColumnName, DynamicField } from "Pages/RecipientsList/model";

export const getAllColumns = (dynamicFields: DynamicField[]): ColumnName[] => {
  const cols: ColumnName[] = [
    "Email",
    "Mobile",
    "EmailSubscriptionStatus",
    "SMSSubscriptionStatus",
    "Engagement",
    "Groups",
    "RegistrationDate",
    "EmailSubscriptionDate",
    "EmailPendingDate",
    "EmailUnsubscriptionDate",
    "ReasonEmail",
    "ConfirmedOptin",
    "SMSSubscriptionDate",
    "SMSUnsubscriptionDate",
    "ReasonSms",
    "TrackingState",
    "TrackingLastChange",
    ...dynamicFields.map(({ id }) => `Field${id}` as ColumnName),
  ];

  return cols;
};
